import { useStore } from "@/stores/useStore.ts";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect } from "react";
import Spinner from "@/components/base/Spinner.tsx";
import { PageHeading } from "@/components/common/PageHeading.tsx";

export const CompanyHome = () => {
  const tenant = useStore((s) => s.tenant);
  const user = useStore((s) => s.user);
  const tenantRole = useStore((s) => s.tenantRole);
  const navigate = useNavigate();
  const allowedTenants = useStore((s) => s.allowedTenants);
  const { tenantId } = useParams();

  useEffect(() => {
    if (allowedTenants && !allowedTenants.find((t) => t.id === tenantId)) {
      navigate("/");
    }
  }, [allowedTenants, tenantId, navigate]);

  if (!tenantId || !user) {
    return null;
  }

  if (tenantId !== tenant?.id) {
    return (
      <div className="flex flex-grow items-center justify-center">
        <Spinner />
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-4 m-auto px-8 py-2">
      <PageHeading>{`Welcome ${user.firstName} to ${tenant.name}'s Home Page`}</PageHeading>
      <div>
        This page might feel sparse, but as features are added and generators
        and appointments are scheduled, this page will become the main location
        to view your upcoming appointments
      </div>
      {tenantRole === "admin" && (
        <p>
          If you would like to invite other users to your company, share{" "}
          <span className="font-bold">{tenant.joinCode}</span> with them.
        </p>
      )}
      <div></div>
    </div>
  );
};
